import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import MarkingCorrectionDatatable from './MarkingCorrectionDatatable';
import MassiveCreateAttendanceForm from './MassiveActios/MassiveCreateAttendanceForm';
import columns from './columns';
import { SimpleCenteredModal } from '../../../components';
import { sendAlert } from '../../../actions/utils';
import { debounceIndexBranchOfficesRequest } from '../../../requests/branchOffices';
import { createMassiveAttendanceRequest } from '../../../requests/attendances';

const MarkingCorrectionIndex = () => {
  const [moreData, setMoreData] = useState(false);
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const [simpleModalBody, setSimpleModalBody] = useState({});
  const [simpleModalTitle, setSimpleModalTitle] = useState('');
  const [branchOffices, setBranchOffices] = useState([]);
  const [size, setSize] = useState('lg');
  const dispatch = useDispatch();

  useEffect(() => window.scrollTo(0, 0), []);

  const fetchBranchOffices = () => {
    debounceIndexBranchOfficesRequest({
      dispatch,
      params: {
        actives: true,
        sort_column: 'name',
        paginate: false
      },
      successCallback: result => {
        setBranchOffices(result.data.data);
      }
    });
  };

  useEffect(fetchBranchOffices, []);

  const handleModalClose = () => {
    setSimpleModalShow(false);
  };

  const handleFailureRequest = error => {
    const { response } = error;

    if (Array.isArray(response?.data?.message)) {
      const groupedErrors = response?.data?.message.map(item => ({
        employee: item.employee,
        errors: [...new Set(item.errors.flat())]
      }));

      const body = groupedErrors.map(errors => (
        <div>
          <p>
            <strong>Trabajador:</strong> {errors.employee}
          </p>
          <p>
            <strong>Errores:</strong> {errors.errors.join(', ')}{' '}
          </p>
          <hr />
        </div>
      ));
      setSimpleModalTitle('Se encontraron los siguiente errores');
      setSimpleModalBody(<>{body}</>);
      setSimpleModalShow(true);
      setSize('lg');
    } else {
      dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
    }
  };

  const handleMassiveCreateAttendanceRequest = (attendance, setSubmitting) => {
    createMassiveAttendanceRequest({
      dispatch,
      params: {
        ...snakeCaseKeys(attendance)
      },
      successCallback: () => {
        setMoreData(!moreData);
        dispatch(
          sendAlert({
            kind: 'success',
            message: 'Solicitud de Creación Masiva de Asistencia Realizada de Manera Correcta'
          })
        );
        handleModalClose();
      },
      failureCallback: error => {
        handleFailureRequest(error);
        setSubmitting(false);
      }
    });
    return true;
  };

  const handleMassiveCreateAttendance = () => {
    setSimpleModalBody(
      <MassiveCreateAttendanceForm
        formRequest={handleMassiveCreateAttendanceRequest}
        handleModalClose={handleModalClose}
        dispatch={dispatch}
        branchOffices={branchOffices}
      />
    );

    setSimpleModalTitle('Agregar Nueva Marcación');
    setSimpleModalShow(true);
    setSize('xl');

    return true;
  };
  return (
    <>
      <Row className="mt-4 mb-2">
        <Col md={9}>
          <h2 className="mb-4 mt-4">Corrección de Marcación</h2>
        </Col>
        <Col md={3} className="mt-3">
          <Button
            className="btn-block text-center"
            disabled={branchOffices.length === 0}
            onClick={() => handleMassiveCreateAttendance()}
          >
            NUEVA MARCACIÓN
          </Button>
        </Col>
      </Row>

      <MarkingCorrectionDatatable
        columns={columns}
        moreData={moreData}
        setMoreData={setMoreData}
        branchOffices={branchOffices}
      />

      <SimpleCenteredModal
        title={simpleModalTitle}
        body={simpleModalBody}
        size={size}
        show={simpleModalShow}
        onHide={handleModalClose}
      />
    </>
  );
};

export default MarkingCorrectionIndex;
